module.exports = __webpack_public_path__ + "fonts/TT-Norms_Bold.41e0211.woff2";